import CUSTOMER_STATE from "../roles/customer/state";
import VISITOR_STATE from "../roles/visitor/state";
export const DEFAULT_STATE = {
  access_token: null,
  refresh_token: null,
  accountID: null,
  username: null,
  fingerprint: null,
  systemInfo: null,
  user: {
    id: null,
    username: "",
    email: null,
    vip: false,
    suspended: false,
  },
  secure: null,
  accountList: [],
  profile: {
    segment_id: null,
    donation: 0,
    preferred_currency: "usd",
    username: null,
  },
  preferredCrypto: "btc",
  ...CUSTOMER_STATE,
  ...VISITOR_STATE,
};
